module.exports = "/static/images/tagline.svg";